import { render, staticRenderFns } from "./HeaderMain.vue?vue&type=template&id=2d84a920&scoped=true&"
import script from "./HeaderMain.vue?vue&type=script&lang=js&"
export * from "./HeaderMain.vue?vue&type=script&lang=js&"
import style0 from "./HeaderMain.vue?vue&type=style&index=0&id=2d84a920&lang=scss&scoped=true&"
import style1 from "./HeaderMain.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d84a920",
  null
  
)

export default component.exports